/**
 * @file template-editor-transforms.ts
 * @description Трансформы «Handlebars-шаблон ↔ HTML визуального редактора»
 * (phase19.7). Чистые функции, покрыты юнит-тестами.
 *
 * Договорённости:
 *  - инлайн-плейсхолдер `{{path}}` ⇄ чип `<span data-ph="path">…</span>`;
 *  - «Таблица позиций»: `{{#each items}}<tr>…</tr>{{/each}}` ⇄
 *    `<tr data-items-row="true">…</tr>` (редактор видит обычную строку);
 *  - прочие блочные хелперы (`{{#…}}`, `{{^…}}`) визуальный редактор не
 *    поддерживает — шаблон открывается в HTML-режиме с плашкой
 *    (решение пользователя 2026-08-10).
 */

const ITEMS_BLOCK_RE = /\{\{#each items\}\}([\s\S]*?)\{\{\/each\}\}/g;

/** Может ли шаблон открыться в визуальном редакторе без потерь. */
export function isVisualEditable(src: string): boolean {
  const withoutItems = src.replace(ITEMS_BLOCK_RE, "");
  return !/\{\{[#/^]/.test(withoutItems);
}

/** Handlebars-шаблон → HTML для TipTap (чипы + items-строки). */
export function handlebarsToEditorHtml(src: string): string {
  let out = src.replace(ITEMS_BLOCK_RE, (_m, inner: string) =>
    inner.replace(/<tr/i, '<tr data-items-row="true"'),
  );
  out = out.replace(
    /\{\{([^#/^{}][^{}]*)\}\}/g,
    (_m, path: string) => `<span data-ph="${path.trim()}"></span>`,
  );
  return out;
}

/** HTML из TipTap → Handlebars-шаблон (обратный трансформ). */
export function editorHtmlToHandlebars(html: string): string {
  // Чипы → {{path}} (label внутри чипа отбрасывается — источник правды data-ph).
  let out = html.replace(
    /<span[^>]*\bdata-ph="([^"]+)"[^>]*>.*?<\/span>/g,
    (_m, path: string) => `{{${path}}}`,
  );
  // items-строка → {{#each items}}<tr>…</tr>{{/each}}.
  out = out.replace(
    /<tr([^>]*?)\s?data-items-row="true"([^>]*)>([\s\S]*?)<\/tr>/g,
    (_m, pre: string, post: string, inner: string) => {
      const attrs = `${pre}${post}`.trim();
      return `{{#each items}}<tr${attrs ? ` ${attrs}` : ""}>${inner}</tr>{{/each}}`;
    },
  );
  return out;
}

/** HTML умного блока «Таблица позиций» для вставки в редактор. */
export const ITEMS_TABLE_HTML = `
<table>
  <tbody>
    <tr>
      <th><p>№</p></th>
      <th><p>Наименование</p></th>
      <th><p>Кол-во</p></th>
      <th><p>Цена</p></th>
      <th><p>Сумма</p></th>
    </tr>
    <tr data-items-row="true">
      <td><p><span data-ph="index"></span></p></td>
      <td><p><span data-ph="name"></span></p></td>
      <td><p><span data-ph="quantity"></span></p></td>
      <td><p><span data-ph="price"></span></p></td>
      <td><p><span data-ph="total"></span></p></td>
    </tr>
  </tbody>
</table>
`.trim();
